module.exports = function (_value, _mark) {
    if (isNaN(_value) || _value === null || _value === '') {
        return '--';
    } else {
        return (parseFloat(_value) * 100).toFixed(2) + (_mark === true ? '%' : '');
    }
}


// WEBPACK FOOTER //
// ./src/views/dataPlatform/filters/percent-format.js